export const staff = {
  page_heading: "Personal",
  editor_label_identifier: "ID",
};
